export const TWO_FA_EXPIRED_MESSAGE = "2FA expired. Please re-verify.";

let onRefreshSessionFailed = () => {};

export function setRefreshSessionFailedHandler(fn) {
  onRefreshSessionFailed = typeof fn === "function" ? fn : () => {};
}

export function triggerRefreshSessionFailed() {
  onRefreshSessionFailed();
}

let onTwoFaExpired = () => {};

export function setTwoFaExpiredHandler(fn) {
  onTwoFaExpired = typeof fn === "function" ? fn : () => {};
}

export function triggerTwoFaExpired() {
  onTwoFaExpired();
}
